const firstValue = (value) => {
  if (Array.isArray(value)) return value[0];
  return value;
};

const firstMessage = (value) => {
  const message = firstValue(value);
  return typeof message === "string" && message.trim() ? message : undefined;
};

const validationMessages = (value, field = "") => {
  if (typeof value === "string") {
    return value.trim() ? [field ? `${field}: ${value}` : value] : [];
  }
  if (Array.isArray(value)) {
    return value.flatMap((item) => validationMessages(item, field));
  }
  if (value && typeof value === "object") {
    return Object.entries(value).flatMap(([key, item]) =>
      validationMessages(item, field ? `${field}.${key}` : key),
    );
  }
  return [];
};

export const getApiErrorMessage = (error, fallbackMessage) => {
  const payload = error?.response?.data ?? error;
  if (typeof payload === "string") {
    return firstMessage(payload) || fallbackMessage;
  }
  if (Array.isArray(payload)) {
    return (
      payload
        .map((item) => getApiErrorMessage(item))
        .filter(Boolean)
        .join("; ") || fallbackMessage
    );
  }

  const errorData = payload?.errors || payload;
  const errorDetails = Array.isArray(payload?.error_details)
    ? payload.error_details
    : [];

  return (
    firstMessage(errorData?.description_es) ||
    firstMessage(errorData?.description) ||
    firstMessage(errorData?.message) ||
    firstMessage(payload?.description_es) ||
    firstMessage(payload?.description) ||
    firstMessage(payload?.message) ||
    firstMessage(payload?.error) ||
    errorDetails
      .map((detail) => firstMessage(detail?.error_description))
      .filter(Boolean)
      .join("; ") ||
    validationMessages(payload?.errors).join("; ") ||
    firstMessage(error?.message) ||
    fallbackMessage
  );
};

export const getApiErrorKey = (error) => {
  if (Array.isArray(error)) {
    return firstValue(error[0]?.key) || firstValue(error[0]?.error_key) || "";
  }

  const errorData = error?.errors || error?.response?.data?.errors || error;

  return (
    firstValue(errorData?.key) ||
    firstValue(errorData?.error_key) ||
    firstValue(error?.response?.data?.key) ||
    firstValue(error?.response?.data?.error_key) ||
    ""
  );
};
